// GA4 events for the product page brand selector and THT block. Same setup as the quiz: once the visitor allows
// analytics cookies, the Google & YouTube app puts gtag on the page; without consent nothing is sent.
// Both snippets load this file, so it runs once per page.
if (!window.agProductEngagement) {
  window.agProductEngagement = true;
  const GA_MEASUREMENT_ID = 'G-FZR1VDVVK1';

  const track = (name, params) => {
    if (typeof window.gtag !== 'function') return false;
    window.gtag('event', name, { ...params, send_to: GA_MEASUREMENT_ID });
    return true;
  };

  // The link leaves the page before gtag gets to send, so hold the navigation until the hit is out (max 1s).
  const trackLink = (event, link, name, params) => {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
      return track(name, params);
    }
    let followed = false;
    const follow = () => {
      if (followed) return;
      followed = true;
      window.location.href = link.href;
    };
    if (!track(name, { ...params, event_callback: follow })) return;
    event.preventDefault();
    setTimeout(follow, 1000);
  };

  document.querySelectorAll('.product-brand').forEach((brand) => {
    brand.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link || link.getAttribute('aria-current') === 'page') return;
      const params = { brand_name: brand.dataset.brand };
      if (link.classList.contains('product-brand__header')) params.brand_link = 'header';
      else if (link.classList.contains('product-brand__more')) params.brand_link = 'more';
      else {
        params.brand_link = 'product';
        params.brand_position = Number(link.dataset.position);
        params.brand_sold_out = link.classList.contains('product-brand__product--sold-out');
      }
      trackLink(event, link, 'brand_selector_click', params);
    });
  });

  document.querySelectorAll('.product-bbd').forEach((bbd) => {
    const params = { bbd_level: bbd.dataset.level, bbd_days_left: Number(bbd.dataset.daysLeft) };

    // A view counts once, when at least half the block has been on screen.
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          track('bbd_view', params);
        },
        { threshold: 0.5 }
      );
      observer.observe(bbd);
    }

    bbd.querySelector('.product-bbd__info')?.addEventListener('toggle', (event) => {
      if (event.target.open) track('bbd_info_open', params);
    });
  });
}
